/**
 * @generated SignedSource<<eb60dae3fe0491ca0c84a4b30771c044>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedExcellentValuesCarousel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemTilesCarouselModule_user">;
  readonly " $fragmentType": "HpSharedExcellentValuesCarousel_user";
};
export type HpSharedExcellentValuesCarousel_user$key = {
  readonly " $data"?: HpSharedExcellentValuesCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedExcellentValuesCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedExcellentValuesCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedItemTilesCarouselModule_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d36254ad578cee3fb09e5a4d52e80971";

export default node;
